// Real content for Adonica Shaw: author, founder, advocate, software & medical device innovator.

export const AMAZON_STORE =
  "https://www.amazon.com/stores/author/B084Z8PG1P/allbooks";

export const NAV = {
  work: [
    { label: "Projects", href: "#projects", desc: "Software, devices & ventures" },
    { label: "Advocacy", href: "#advocacy", desc: "The causes I stand for" },
    { label: "Values", href: "#values", desc: "The principles behind the work" },
    { label: "Mission", href: "#mission", desc: "Why this work exists" },
  ],
  links: [
    { label: "Story", href: "#story" },
    { label: "Books", href: "#books" },
    { label: "News", href: "#news" },
    { label: "About", href: "#about" },
  ],
  poetry: [
    {
      label: "Spotify",
      href: "https://open.spotify.com/artist/7yzfwW6R89zXtdNla1iUAS",
      desc: "Listen on Spotify",
    },
    {
      label: "Apple Music",
      href: "https://music.apple.com/us/artist/adonica-shaw/1838407406",
      desc: "Listen on Apple Music",
    },
    {
      label: "iHeartRadio",
      href: "https://www.iheart.com/artist/adonica-shaw-47977369",
      desc: "Listen on iHeartRadio",
    },
  ],
};

export const HERO = {
  role: "Advocate · Educator · Author · Founder",
  intro:
    "Advocate and educator for women's health and justice, four-time TEDx speaker, and author of nineteen books, teaching, building, and fighting for the care and rights women are too often denied.",
};

export const MARQUEE_WORDS = [
  "Women's Health",
  "Femtech",
  "Software",
  "Medical Devices",
  "Advocacy",
  "Reinvention",
];

export const ABOUT = {
  eyebrow: "The Bio",
  heading: "Love live and ready to fight... for change.",
  body: [
    "Adonica Shaw is an advocate, educator, entrepreneur and author whose work sits at the intersection of women's health, justice, engineering and storytelling. She is the founder of Wingwomen, a company reborn across several iterations, from a peer support platform, to surgical device work under Operyx, to an AI Health Navigator built on Anthropic's Claude.",
    "Her work is shaped by lived experience: a code blue eclamptic crisis during the birth of her third child. A trained doula and student midwife, she was named one of the Top 136 Black Innovators in STEM and Arts by Wonder Women Tech, and her portfolio spans more than twenty women's health technologies.",
  ],
  stats: [
    { value: "19", label: "Books published" },
    { value: "20+", label: "Health technologies" },
    { value: "4×", label: "TEDx speaker" },
    { value: "136", label: "Top Black Innovators in STEM" },
  ],
  accolades: [
    "FemTech Device of the Year, MedTech World",
    "Nasdaq Milestone Makers",
    "Wharton Entrepreneurship Growth Accelerator",
    "Contributor, TechCrunch",
  ],
};

export const STORY = {
  eyebrow: "The Story",
  heading: "A Life Measured in Reinventions.",
  chapters: [
    {
      no: "01",
      title: "Wingwomen",
      lead: "Building technology around lived experience.",
      body: "Wingwomen transforms Adonica's reproductive health experience into AI-powered tools, peer connection, and support for women navigating healthcare.",
    },
    {
      no: "02",
      title: "Advocacy",
      lead: "Turning survival into advocacy.",
      body: "Her experiences with reproductive coercion and sexual violence shaped a commitment to reproductive justice, survivor rights, safety, and the right to rebuild.",
    },
    {
      no: "03",
      title: "Medical Device Design",
      lead: "Redesigning what was never designed well enough.",
      body: "Blending clinical experience, technology, and a lifelong love of art and design, Adonica creates medical devices built around real bodies and real clinical needs.",
    },
    {
      no: "04",
      title: "Books",
      lead: "Making hard-earned lessons useful.",
      body: "Her books transform experiences of motherhood, healthcare, entrepreneurship, loss, and reinvention into stories and ideas people can understand, carry, and use.",
    },
    {
      no: "05",
      title: "Poetry",
      lead: "Giving experience another language.",
      body: "Writing began in childhood and became poetry, a lifelong practice of turning observation, emotion, and lived experience into creative expression.",
    },
  ],
};

export const BOOKS = {
  eyebrow: "The Books",
  heading: "Titles dedicated to finding your voice, becoming accountable, healing, justice and the work of starting over.",
  featured: {
    title: "Earned Wisdom",
    subtitle: "Pieces of Wisdom I Acquired While Building My Healthcare Start-up Wingwomen",
    blurb:
      "The founder's field notes: hard-won lessons from building a women's health company across failure, reinvention and return.",
    cover: "https://m.media-amazon.com/images/I/71yfqMKeRiL._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
    href: "https://www.amazon.com/Earned-Wisdom-Acquired-Healthcare-Wingwomen-ebook/dp/B0GCBD5FGM",
  },
  grid: [
    {
      title: "What No One Tells You About Motherhood",
      cover: "https://m.media-amazon.com/images/I/71VaXWx5s1L._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
      href: "https://www.amazon.com/What-One-Tells-About-Motherhood-ebook/dp/B0GF3BF3W7",
    },
    {
      title: "The Postpartum Palette Cookbook",
      cover: "https://m.media-amazon.com/images/I/71YXCf5f-bL._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
      href: "https://www.amazon.com/Postpartum-Palette-Cookbook-Culinary-Trimester-ebook/dp/B0F4H557VN",
    },
    {
      title: "You Know She's Crazy, Right?",
      cover: "https://m.media-amazon.com/images/I/71pbSGNrbuL._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
      href: "https://www.amazon.com/Know-Shes-Crazy-Right-Heart-Centered-ebook/dp/B0G44XKHKQ",
    },
    {
      title: "Between Harm and Justice",
      cover: "https://m.media-amazon.com/images/I/81d6Fuu1CqL._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
      href: "https://www.amazon.com/Between-Harm-Justice-Limits-Assault-ebook/dp/B0GCD94Q8Y",
    },
    {
      title: "Forty Days to Fearless",
      cover: "https://m.media-amazon.com/images/I/61WQDttaUCL._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
      href: "https://www.amazon.com/Forty-Days-Fearless-Principles-Themselves-ebook/dp/B0G6DDQJ88",
    },
    {
      title: "Chuck & Buttercup",
      cover: "https://m.media-amazon.com/images/I/61vVZ7l8NTL._AC_CR0%2C0%2C0%2C0_SY315_.jpg",
      href: "https://www.amazon.com/Chuck-Buttercup-Lessons-Learned-Addiction-ebook/dp/B0F2BYJNXC",
    },
  ],
  upcoming: [
    {
      title: "The Space Where Petals Fall",
      date: "Oct 6, 2026",
      href: "https://www.amazon.com/Space-Where-Petals-Fall-ebook/dp/B0G4WB38DZ",
    },
    {
      title: "The Social Lives of Porcupines",
      date: "Sep 22, 2026",
      href: "https://www.amazon.com/Social-Lives-Porcupines-Adonica-Shaw-ebook/dp/B0G549MP8X",
    },
  ],
};

export const PROJECTS = {
  eyebrow: "The Technology",
  heading: "More than twenty women's health technologies, spanning AI, software and titanium.",
  items: [
    {
      name: "Wingwomen",
      tag: "AI Platform",
      href: "https://www.mywingwomen.com",
      body: "AI-powered peer support, private community hubs, and an AI Health Navigator built on Anthropic's Claude, relaunched in 2026.",
    },
    {
      name: "Qualmitta",
      tag: "Regulatory Software",
      href: "https://www.qualmitta.com",
      body: "A therapeutics platform with teams, research, documentation and workflow tools, powered by Chuck, an AI regulatory specialist for FDA research, submissions and predicate analysis.",
    },
    {
      name: "NuPDocs",
      tag: "Documentation Software",
      href: "https://www.nupdocs.com",
      body: "A documentation platform that streamlines the clinical and regulatory paperwork behind bringing health products safely to market.",
    },
    {
      name: "ClockIt Parents",
      tag: "Mobile App · iOS & Android",
      href: "https://www.clockitparents.com",
      body: "A custody and visitation tracking app for iOS and Android, helping co-parents log time, exchanges and agreements with clarity and accountability.",
    },
    {
      name: "SHIFT Nurse: Rise",
      tag: "Mobile Game · Apple App Store",
      href: "https://www.shiftnursegame.com",
      body: "Build your nurse, own every shift. A career-mode nursing game with 40+ clinical scenarios, 15 career levels and 9 specialty units, plus a no-energy Study Mode for real nursing students.",
    },
    {
      name: "NINA",
      tag: "Biodata",
      body: "An AI-driven biodata platform reimagining gynecological tools and collecting the reproductive health data research has long overlooked.",
    },
    {
      name: "Operyx",
      tag: "Medical Devices",
      body: "Surgical tool development and medical device manufacturing, engineering instruments around the bodies they serve.",
    },
    {
      name: "Calibryx Forceps",
      tag: "Surgical Instrument",
      body: "Titanium atraumatic forceps, an ergonomic redesign recognized as FemTech Device of the Year by MedTech World.",
    },
  ],
};

export const VALUES = {
  eyebrow: "The Values",
  heading: "Four principles I refuse to compromise.",
  items: [
    {
      no: "01",
      title: "Radical Self Advocacy",
      body: "Women deserve to be believed before they are treated. Every product and page begins there.",
    },
    {
      no: "02",
      title: "Evidence & Craft",
      body: "Empathy is the brief; engineering is the discipline. Beautiful things that also hold up under load.",
    },
    {
      no: "03",
      title: "Lived Experience",
      body: "The work is authored by someone who has been the patient, not just studied one.",
    },
    {
      no: "04",
      title: "Relentless Reinvention",
      body: "A crisis, a pivot, a return. Progress rarely arrives in a straight line, and that's allowed.",
    },
  ],
};

export const ADVOCACY = {
  eyebrow: "Advocacy & Education",
  heading: "The causes I advocate for, and teach.",
  intro:
    "Advocacy is not separate from the work, it is the reason for it. Alongside these fights, I educate audiences, students and boards on what the systems get wrong and how we change them, lending my voice, my platform and my time.",
  areas: [
    {
      no: "01",
      title: "Reproductive Justice",
      body: "Bodily autonomy and equitable access to reproductive care for every person, everywhere.",
    },
    {
      no: "02",
      title: "Sexual Assault Survivors' Rights",
      body: "Believing survivors, and reforming the systems that are meant to protect them.",
    },
    {
      no: "03",
      title: "Civil Gideon Protections",
      body: "The right to counsel in civil, domestic violence, custody and divorce cases, so justice is not reserved for those who can afford it.",
    },
    {
      no: "04",
      title: "Public Figure Defense Rights",
      body: "Fair process and real protection for those who live and work under public scrutiny.",
    },
    {
      no: "05",
      title: "Transparent Investment Rights for Tech Companies and Founders",
      body: "Clear, honest terms so founders and companies can raise capital without being exploited.",
    },
  ],
};

export const POETRY = {
  eyebrow: "The Poetry",
  heading: "Spoken word and oral essays for the tender parts.",
  intro:
    "Under Wingwomen Omnimedia, Adonica writes and performs poetry and oral essays on reproductive health, loss, healing and the work of starting over. Listen on your platform of choice.",
  works: [
    { no: "01", title: "Fragmented", meta: "Single · 2025" },
    { no: "02", title: "Half of You", meta: "Single · 2025" },
    {
      no: "03",
      title: "Singles & Oral Essays, Vol. 1",
      meta: "Collection · Wingwomen Omnimedia · 2025",
    },
  ],
  platforms: [
    { name: "Spotify", href: "https://open.spotify.com/artist/7yzfwW6R89zXtdNla1iUAS" },
    { name: "Apple Music", href: "https://music.apple.com/us/artist/adonica-shaw/1838407406" },
    { name: "iHeartRadio", href: "https://www.iheart.com/artist/adonica-shaw-47977369" },
  ],
};

export const RECONCILIATION = {
  eyebrow: "New Advocacy Project",
  title: "Reproductive Reconciliation",
  body: "An education and advocacy hub for survivors of sexual assault and reproductive coercion, a place to learn, to be believed, and to begin again.",
  cta: "Visit reproductivereconciliation.com",
  href: "https://www.reproductivereconciliation.com",
};

export const MISSION = {
  eyebrow: "The Mission",
  statement:
    "To create products that contribute to the positive wellbeing of men, women and children across healthcare, law and self-development.",
  supporting:
    "That means software and devices engineered based on real use cases, technology that listens before it prescribes, and books that say the quiet parts out loud.",
};

export const ROOTS = {
  eyebrow: "Roots & Education",
  heading: "Pasadena born. Shaped by many places.",
  body: "Born in Pasadena, California, and raised between Youngstown, Ohio and Upland, California, Adonica carries the imprint of every place that made her, and the discipline of the programs that trained her.",
  image: "/roots-childhood.jpg",
  education: [
    "UC Irvine",
    "MIT Bootcamps (MIT Harvard Medical, MIT Sloan Ventures)",
    "Wharton",
    "Duke",
    "National Midwifery Institute",
  ],
  certifications: ["DONA Doula", "Certified Integrative Health Coach"],
};

export const NEWS = {
  eyebrow: "In The News",
  heading: "Recent media around the obstetric forceps redesign.",
  featured: {
    source: "AfroTech",
    kicker: "Feature",
    title:
      "Redesigning a 400-year-old birth-room tool for women's health.",
    blurb:
      "Inside the Shawryx Titanium Obstetric Forceps, the first obstetric forceps platform redesigned by a woman in the instrument's 400-year history, and the first of its kind to earn an FDA exemption.",
    image:
      "https://images.unsplash.com/photo-1631162065488-0b2675acb2b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    href: "https://afrotech.com/adonica-shaw-redesigning-medical-devices-for-womens-health-general-surgery",
  },
  items: [
    {
      source: "TechCrunch",
      title: "Adonica Shaw, features and contributions",
      href: "https://techcrunch.com/author/adonica-shaw/",
    },
    {
      source: "Yahoo News",
      title: "The founder behind the redesign of obstetric forceps",
      href: "https://www.yahoo.com/news/articles/founder-adonica-shaw-behind-redesign-153324481.html",
    },
    {
      source: "Face2Face Africa",
      title: "How this founder redesigned a medical device to improve childbirth safety",
      href: "https://face2faceafrica.com/article/how-this-founder-redesigned-a-popular-medical-device-to-improve-safety-in-childbirth-after-her-complications",
    },
    {
      source: "MedTech World",
      title: "Transforming gynecological health with NINA",
      href: "https://med-tech.world/news/transforming-gynecological-health-adonica-shaw-nina/",
    },
  ],
};

export const BOOKING = {
  eyebrow: "Speaking & Education",
  heading: "Invite Adonica to speak, teach or advise.",
  body: "Keynotes, workshops, lectures and fireside conversations on women's health, reproductive justice, survivor advocacy, maternal care and building through reinvention, for conferences, universities, boards, healthcare teams and media.",
  topics: [
    "Reproductive Justice & Survivor Advocacy",
    "Maternal Health Education",
    "Femtech & Women's Health Innovation",
    "Doula & Midwifery Education",
    "Building & Rebuilding a Startup",
    "Resilience After Crisis",
  ],
};
